import * as React from 'react';

const FuelShortageWarning = () => (
  <div className="fuel-shortage-warning">
    <p>Please note:</p>
    <p>We don't cover cancellations, extra flight costs, or unused accommodation caused by fuel shortages affecting flights. For refunds or other options, please speak to your airline or travel provider.</p>
  </div>
);

export default FuelShortageWarning;
